import actions from "./actions";

const initialState = {
  list: [],
  detail: {},
  loading: false,
  meta: {},
  error: false,
  isWidgetChannelStateFetched: false,
};

export default function widgetChannelStateReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
